import { call, put, takeLatest } from "redux-saga/effects";
import actionCreators from "../../actions/top/my_circle_list";
import "babel-polyfill";

function* fetchCircles() {
  try {
    const data = yield call(function() {
      const method = "GET";
      const credentials = "include";
      const mode = "no-cors";
      const headers = {
        Accept: "application/json",
        "Content-Type": "application/json",
      };
      return fetch("/api/mypage/my_circles", {
        method,
        credentials,
        mode,
        headers,
      })
        .then((response) => response.json())
        .catch((xhr) => {
          throw xhr.status;
        });
    });
    yield put(
      actionCreators.top.mycircles.success({ myCircles: data.users_circles })
    );
  } catch (e) {
    yield put(actionCreators.top.mycircles.failure(e));
  }
}

export default function*() {
  yield takeLatest(actionCreators.top.mycircles.set, fetchCircles);
}
